import {
  CONFIRMED_GET_DISEASE_MEDICINE_MAPPINGS,
  CONFIRMED_CREATE_DISEASE_MEDICINE_MAPPING_ACTION,
  CONFIRMED_DELETE_DISEASE_MEDICINE_MAPPING_ACTION,
  CONFIRMED_EDIT_DISEASE_MEDICINE_MAPPING_ACTION,
} from "../actions/DiseaseMedicineMappingType";

const initialState = {
  mappings: [],
};

export default function DiseaseMedicineMappingReducer(state = initialState, action) {
  switch (action.type) {
    case CONFIRMED_GET_DISEASE_MEDICINE_MAPPINGS:
      return {
        ...state,
        mappings: action.payload,
      };

    case CONFIRMED_CREATE_DISEASE_MEDICINE_MAPPING_ACTION:
      return {
        ...state,
        mappings: [...state.mappings, action.payload],
      };

      case CONFIRMED_DELETE_DISEASE_MEDICINE_MAPPING_ACTION:
        return {
          ...state,
          mappings: state.mappings.filter(
            (m) => m.disease_medicine_id !== action.payload.disease_medicine_id
          ),
        };
      

    case CONFIRMED_EDIT_DISEASE_MEDICINE_MAPPING_ACTION:
      return {
        ...state,
        mappings: state.mappings.map((m) =>
          m.disease_medicine_id === action.payload.disease_medicine_id
            ? { ...m, ...action.payload }
            : m
        ),
      };

    default:
      return state;
  }
}
